import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import app from './app';
import auth from './auth';
import user from './user';
import products from './products';
import soldProducts from './soldProducts';
import requestFunds from './requestFunds';
import payout from './payout';
import transactions from './transactions';
import transactionGraph from './transactionGraph';
import branches from './branches';
import outletDetails from './outletDetails';

const rootReducer = combineReducers({
  app,
  auth,
  user,
  products,
  soldProducts,
  requestFunds,
  payout,
  transactions,
  transactionGraph,
  branches,
  outletDetails,
  router: routerReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/index.js